import React from 'react';
import PropTypes from 'prop-types';


export default class CustomCheckbox extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selected: props.isSelected
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const { itemId, onItemSelected } = this.props;
        const value = event.target.checked;

        onItemSelected(itemId, event.target.checked);
        this.setState({ selected: value });
    }

    render() {
        return (
            <input type="checkbox" className="k-checkbox" 
                    id={this.props.itemId}
                    checked={this.state.selected}
                    onChange={this.handleChange} />
        );
    }

}

CustomCheckbox.propTypes = {
    itemId: PropTypes.any.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onItemSelected: PropTypes.func
};